
import { Vue, Component, Prop } from "vue-property-decorator";
import Actividades from "@/components/Actividades/Actividades.vue";

@Component({
  components: {
    Actividades
  }
})
export default class CategoriasView extends Vue {
  private mounted() {}
}
